import { render, staticRenderFns } from "./SuggestMap.vue?vue&type=template&id=15196094&"
import script from "./SuggestMap.vue?vue&type=script&lang=js&"
export * from "./SuggestMap.vue?vue&type=script&lang=js&"
import style0 from "./SuggestMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports